export function addRotateImageEditing(editor) {
    editor.model.schema.extend('imageBlock', {
        allowAttributes: ['style']
    });
    editor.model.schema.extend('imageInline', {
        allowAttributes: ['style']
    });

    editor.conversion.for('downcast').add(dispatcher => {
        dispatcher.on('attribute:style:imageBlock', updateStyle);
        dispatcher.on('attribute:style:imageInline', updateStyle);

        function updateStyle(evt, data, conversionApi) {
            const viewWriter = conversionApi.writer;
            const viewElement = conversionApi.mapper.toViewElement(data.item);
            const viewImg = viewWriter.createPositionAt(viewElement, 0).nodeAfter;
            if (viewImg) {
                viewWriter.setAttribute('style', data.attributeNewValue, viewImg);
            }
        }
    });
}
